export default "__VITE_ASSET__b20a74be__"